import './main.less';

import React from 'react';
import PropTypes from 'prop-types';

import facebookIcon from '../../../../assets/img/market/facebook.svg';
import vkIcon from '../../../../assets/img/market/vkontakte.svg';
import telegramIcon from '../../../../assets/img/market/telegram.svg';
import cpaClubIcon from '../../../../assets/img/market/cpaclub.svg';
import mailIcon from '../../../../assets/img/market/mail.svg';
import skypeIcon from '../../../../assets/img/market/skype.svg';

const Main = ({ intl }) => (
	<div className='footer'>
		<div className='container'>
			<div className='footer-wrap'>
				<div className='footer-item footer-left'>
					<div className="footer-left__item">
						<div className="footer-left__img">
							<img src={skypeIcon} alt="skype"/>
						</div>
						<a
							href="skype:rocketprofit.cpa" className="footer-left__link">rocketprofit.cpa</a>
					</div>
					<div className="footer-left__item">
						<div className="footer-left__img">
							<img src={mailIcon} alt="mail"/>
						</div>
						<a
							href="mailto:support@rocketprofit.com" className="footer-left__link">support@rocketprofit.com</a>
					</div>
				</div>
				<div className="footer-item footer-center">
					<p className="footer-center__text">© 2014-<span className="date-0" data-format="year">
						{(new Date()).getFullYear()}</span>&nbsp;
					{intl('RocketProfit. All rights reserved.')}
					</p>
					<a
						href="https://www.iubenda.com/privacy-policy/35715717"
						className="privacy-policy"
					>{intl('Privacy policy')}</a>
				</div>
				<div className="footer-item footer-right">
					<a
						className="footer-right__link"
						href="https://www.facebook.com/RocketProfit.ru">
						<img src={facebookIcon} alt="facebook"/>
					</a>
					<a
						className="footer-right__link"
						href="https://vk.com/rocketprofit">
						<img src={vkIcon} alt="vkontakte"/>
					</a>
					<a
						className="footer-right__link"
						href="https://t.me/rocketprofitchat">
						<img src={telegramIcon} alt="telegram"/>
					</a>
					<a
						className="footer-right__link"
						href="http://cpaclub.org">
						<img src={cpaClubIcon} alt="cpaclub"/>
					</a>
				</div>
			</div>
		</div>
	</div>
);

Main.propTypes = {
	intl: PropTypes.func
};

export default Main;



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/footer/main.js